//RBAC data returned by the backend.
export interface RbacPayload {
  roles: string[];
  permissions: string[];
}


//Response returned by the RBAC API.

export interface RbacTokenResponse {
  rbac_token: string;
  rbac: RbacPayload;
}

/**
 * Stores the RBAC request status and the returned token and permissions.
 * RBAC data is kept in NgRx and loaded when the application starts.
 */
export interface RbacState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  rbacToken: string | null;
  rbac: RbacPayload | null;
}

export const initialRbacState: RbacState = {
  status: 'idle',
  rbacToken: null,
  rbac: null,
};